Object.defineProperty(exports,"__esModule",{value:true});var _PageStateContext=require('./PageStateContext');exports.default=

_PageStateContext.Consumer;